import { memo } from 'react';
import { useSmoothClock } from '../../hooks/useSmoothClock';
import './PlayerClock.css';

interface PlayerClockProps {
  time: number;       // ms remaining
  isActive: boolean;  // active turn?
  isLow: boolean;     // under 10s?
}

export default memo(function PlayerClock({ time, isActive, isLow }: PlayerClockProps) {
  // `time` only advances at the store's tick rate, which is far coarser than
  // the hundredths shown below 10s — interpolate between updates so the digits
  // flow instead of stepping. See useSmoothClock for the timing invariants.
  const display = useSmoothClock(time, isActive);

  const className = [
    'player-clock',
    isActive && 'active',
    isLow && 'low-time',
  ].filter(Boolean).join(' ');

  return (
    // role="timer" implies aria-live="off", so a screen reader announces the
    // clock on demand rather than reading out every hundredth.
    <span className={className} data-testid="player-clock" role="timer">
      {display}
    </span>
  );
});
